import request from '@/utils/request';

const PATH = '/board-category';

// 사업자 관리자 1:1 문의 게시판
export const getBoardCategorylistAll = (uid: string) => request({
  url: `${PATH}/list/all/${uid}`,
  method: 'get',
});
